// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3LAEn","load1":"Spinner_load1__1QgwU"};